import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { navigate } from '@reach/router';
import ListItemText from '@material-ui/core/ListItemText';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
interface NavMenuItemProps {
  icon: IconProp;
  route: string;
  label: string;
  location: { pathname: string };
}
const useStyles = makeStyles((theme) => ({
  selected: {
    borderRight: `3px solid ${theme.palette.primary.main}`,
    backgroundColor: '#f5f5f5',
  },
}));

export const NavMenuItem = (props: NavMenuItemProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSelected = props.route
      ? props.location.pathname.startsWith(`/${props.route}`)
      : props.location.pathname === '/';
  const itemClass = ` ${isSelected ? classes.selected : ''}`;
  return(
  <ListItem
    button
    key={props.route}
    onClick={() => navigate(`/${props.route}`)}
    className={itemClass}
  >
    <ListItemIcon>
      {<FontAwesomeIcon icon={props.icon} size="2x" fixedWidth color={isSelected ? theme.palette.primary.main : undefined}/>}
    </ListItemIcon>
    <ListItemText style={{fontSize: '10px'}} primary={props.label} primaryTypographyProps={{style: { fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? theme.palette.primary.main : undefined }
  }}/>
  </ListItem>
  )
};
